export default __webpack_public_path__ + "static/key-brain--yellow-23a2e382e344eb7ee53b061a9c396276.png";